import { useState } from 'react';
import './FAQ.css';

const FAQItem = ({ question, answer, isOpen, onClick }) => (
  <div className={`faq__item ${isOpen ? 'faq__item--open' : ''}`} onClick={onClick}>
    <div className="faq__question">
      <h3>{question}</h3>
      <div className="faq__icon">
        <i className={`fas fa-${isOpen ? 'minus' : 'plus'}`}></i>
      </div>
    </div>
    <div className="faq__answer">
      <p>{answer}</p>
    </div>
  </div>
);

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'Qual o prazo mínimo para solicitar um orçamento?',
      answer: 'Recomendamos solicitar o orçamento com pelo menos 15 dias de antecedência. Para eventos de grande porte, o ideal é entrar em contato com 30 dias ou mais. Porém, atendemos demandas urgentes conforme disponibilidade.'
    },
    {
      question: 'O preço inclui montagem e desmontagem?',
      answer: 'Sim! Nosso serviço é completo. O valor inclui transporte, montagem, operação técnica durante o evento, desmontagem e retirada dos equipamentos. Você não precisa se preocupar com nada.'
    },
    {
      question: 'Qual o tamanho mínimo e máximo dos painéis?',
      answer: 'Trabalhamos com painéis modulares que podem ser configurados de 2m² até 100m² ou mais. A configuração ideal depende do tipo de evento, distância do público e ambiente (interno ou externo).'
    },
    {
      question: 'Os painéis funcionam em ambientes externos?',
      answer: 'Sim, temos painéis específicos para uso externo (outdoor) com alta luminosidade e proteção contra chuva e poeira (IP65). São ideais para shows, festivais e eventos ao ar livre.'
    },
    {
      question: 'Vocês atendem fora de Belo Horizonte?',
      answer: 'Sim! Atendemos em toda a região metropolitana de BH e também em outras cidades de Minas Gerais e estados vizinhos. Consulte-nos para verificar a disponibilidade para sua localidade.'
    },
    {
      question: 'Como funciona o suporte técnico durante o evento?',
      answer: 'Nossa equipe técnica permanece no local durante todo o evento, monitorando os equipamentos e garantindo o funcionamento perfeito. Em caso de qualquer necessidade, temos profissionais prontos para agir imediatamente.'
    },
    {
      question: 'Vocês fazem instalação de painéis em shoppings?',
      answer: 'Sim! Além de locações para eventos, oferecemos instalações de longa duração e permanentes para shoppings, lobbies corporativos e fachadas. Fornecemos também manutenção preventiva e gerenciamento de conteúdo remoto.'
    },
    {
      question: 'Os painéis podem ser usados como outdoor publicitário?',
      answer: 'Sim. Temos painéis LED outdoor com alta luminosidade (acima de 6.000 nits) projetados para publicidade em fachadas e espaços abertos. São visíveis mesmo sob luz solar direta e podem exibir conteúdo dinâmico 24h por dia.'
    },
    {
      question: 'Vocês atendem igrejas e eventos religiosos?',
      answer: 'Com certeza! Atendemos igrejas de todos os portes com telões para cultos, conferências e eventos especiais. Oferecemos tanto locação temporária quanto projetos de instalação fixa com suporte completo.'
    },
    {
      question: 'Qual a diferença entre painéis P2, P3 e P4?',
      answer: 'O número "P" indica o pixel pitch, ou seja, a distância em milímetros entre cada LED. P2 tem LEDs mais próximos (maior resolução, ideal para distâncias curtas como lobbies e shoppings), enquanto P4 tem LEDs mais espaçados (ideal para grandes distâncias como shows e outdoors). Nossa equipe ajuda a escolher o melhor para seu projeto.'
    }
  ];

  return (
    <section className="faq">
      <div className="section-container">
        <div className="section-header" data-aos="fade-up">
          <span className="section-label">Dúvidas Frequentes</span>
          <h2>Perguntas que você pode <span>estar se fazendo</span></h2>
          <p>Reunimos as principais dúvidas dos nossos clientes. Se não encontrar a sua, fale conosco!</p>
        </div>

        <div className="faq__list" data-aos="fade-up">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
